import type { CSSProperties } from 'react';
import EyeIconSvg from '../../assets/icons/eye.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const EyeIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor !important',
        ...style,
    };

    return <EyeIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default EyeIcon;
